module.exports = __webpack_public_path__ + "static/media/FRAX-FXS.131cb985.png";